import { StatusBadge, type StatusBadgeSize } from './StatusBadge'

interface TopExpertBadgeProps {
  size?: StatusBadgeSize
  className?: string
}

/**
 * Top Expert badge displayed alongside member names across the platform.
 * Uses a gold/amber colour scheme to distinguish from Pro (brand-primary).
 *
 * This is the single Top Expert visual. Some surfaces previously rendered
 * `<Badge variant="expert">Top Expert</Badge>` instead, so the same status had
 * two different looks depending on the screen.
 */
export function TopExpertBadge({ size = 'md', className }: TopExpertBadgeProps) {
  return (
    <StatusBadge
      size={size}
      tone="bg-amber-50 text-amber-700 border border-amber-200"
      title="Recognised CRM Top Expert"
      className={className}
      icon={(cls) => (
        <svg viewBox="0 0 16 16" fill="currentColor" className={cls}>
          <path d="M8 0l2.5 5.3L16 6.2l-4 3.8 1 5.5L8 12.8l-5 2.7 1-5.5-4-3.8 5.5-.9z" />
        </svg>
      )}
    >
      Top Expert
    </StatusBadge>
  )
}
